import { Base } from 'active-resource';
import APILibrary, { ClassExtender, GConstructor, GenerateResource } from './APILibrary';
import { GeographyResource } from './Geography';

/**
 * Relationship classes
 */
export class GeographyOptionAttributes {
  id: string = null;
  title: string = null;
  category: string = null;
  description?: string = null;
  geographyId?: string;
}

export class GeographyOptionBelongsTo {
  geography: () => GeographyResource = () => new GeographyResource();
}

export class GeographyOptionHasOne {}
export class GeographyOptionHasMany {}

/**
 * Utility interfaces
 */
export interface GeographyOptionMethods {}

export interface GeographyOptionInterface
  extends GeographyOptionAttributes,
    GeographyOptionBelongsTo,
    GeographyOptionType {}

type GeographyOptionType = GConstructor<GeographyOptionInterface>;

export interface GeographyOptionResource
  extends Base<GeographyOptionAttributes>,
    GeographyOptionInterface,
    GeographyOptionMethods {}

/**
 * Resource methods
 */
const BaseClass = () =>
  GenerateResource<GeographyOptionAttributes>({
    queryName: 'geography_options',
    className: 'GeographyOption',
    AttributesClass: GeographyOptionAttributes,
    BelongsToClasses: [
      {
        Klass: GeographyOptionBelongsTo,
      },
    ],
  });

export const GeographyOptionResourceClass = <TBase extends GeographyOptionType>(
  BaseConstructor: TBase,
): TBase => class extends BaseConstructor implements GeographyOptionMethods {};

export class GeographyOptionResource extends ClassExtender<GeographyOptionInterface>(
  BaseClass,
  GeographyOptionResourceClass,
) {}

/**
 * Resource instance
 */
export const GeographyOption =
  APILibrary.createResource<GeographyOptionResource>(GeographyOptionResource);
